import { lazy, type FC } from 'react';
import { useOptionalIipService } from 'src/apis/iip-service/use-iip-service';
import { PageSpinner } from 'src/components/spinner-container';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';

const Page = lazy(() => import('./page'));

export const NotificationSettings: FC = () => {
  const iipService = useOptionalIipService();
  const monolithUser = useOptionalAuthenticatedMonolithUser();

  if (iipService.response === null && iipService.error === null)
    return <PageSpinner />;

  return <Page iipService={iipService} monolithUser={monolithUser} />;
};
